define('app-CarouselGalleryComponent/main',['./settings', '../app-CarouselComponent/modules', 'bootstrap'],
    function (settings, modules) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Gallery Widgets found.  app-CarouselGalleryComponent will not be available.');
                    return;
                }

                $('.carouseltest').carousel({
                    wrap: false
                })
                //Initialize carousel
                $('.carousel').each(function (index) {
                    var currentCarousel = $(this);
                    var current = $(currentCarousel).find(".carousel-inner");
                    $('.carousel-item', currentCarousel).each(function () {
                        var next = $(this).next();
                        var currentItem = $(this);
                        if (!next.length) next = $(currentItem).siblings(':first');
                        next.children('.original').clone().removeClass('original').addClass('fadedNext').insertAfter($('.original', currentItem));

                    });
                    $('.carousel-item', currentCarousel).each(function () {
                        var prev = $(this).prev();
                        if (!prev.length) prev = $(this).siblings(':last');
                        prev.children('.original').clone().removeClass('original').addClass('fadedPrev').prependTo($(this));
                    });

                    //Get smallest slide height
                    var minImageHeight = $('.carousel-item.active img.original', currentCarousel).attr('data-height');
                    $('.carousel-item', currentCarousel).each(function () {
                        var thisImageHeight = $(this).find('img.original').attr('data-height');
                        if (thisImageHeight < minImageHeight) {
                            minImageHeight = thisImageHeight;
                        }
                    });

                    $('.carousel-item img', currentCarousel).css('max-height', minImageHeight + 'px').attr('data-max', minImageHeight);
                    

                    //Fade Next Content
                    if ($(currentCarousel).find(".galleryContent").hasClass('fadeNextContent')) {
                       
                        $('.Individual', currentCarousel).each(function () {
                            var next = $(this).next();
                            if (!next.length) next = $(this).siblings(':first');
                            next.children('.original').clone().removeClass('original').addClass('container fadedContentNext').insertAfter($('.Individual-inner', this));

                        });
                    }

                    //$('.carousel-item', currentCarousel).css('visibility', 'hidden');

                    //$('.carousel-item', currentCarousel).show();

                    setTimeout(function () {
                        ResizeCarousel(currentCarousel);
                        modules.sliderControls(currentCarousel);
                        caption(currentCarousel);
                    }, 1000);

                    
                    $('.vimeoVideo', currentCarousel).show();
                });

                $(window).resize(function () {
                    $('.carousel').each(function () {
                        var currentCarousel = $(this);
                        ResizeCarousel(currentCarousel);
                        caption(currentCarousel);
                    });

                });

                function ResizeCarousel(currentCarousel) {
                    
                    //Get Biggest content height
                    var maxContentHeight = 0;
                    $('.Individual', currentCarousel).each(function () {
                        $(this).css('visibility', 'visible').show();
                        var thisContentHeight = $(this).outerHeight();
                        if (thisContentHeight > maxContentHeight) {
                            maxContentHeight = thisContentHeight;
                        }
                        $(this).removeAttr('style');
                    });

                    $('.carousel-item img', currentCarousel).removeAttr("style");

                    //Get smallest slide height

                    var carouselImageOrder = $(currentCarousel).hasClass('carouselGalleryBlogs') ? ".original img" : "img.original";

                    var minImageHeight = $('.carousel-item.active img.original', currentCarousel).height();
                    $('.carousel-item', currentCarousel).each(function () {
                        $('.carousel-item img', currentCarousel).removeAttr('style');
                        var thisImageMaxHeight = $(this).find(carouselImageOrder).attr('data-max');


                        var thisImageHeight = $(this).find(carouselImageOrder).height();

                        /*Check if image is broken*/
                            if (thisImageHeight > 32 && thisImageHeight < minImageHeight) {

                                if (thisImageHeight < thisImageMaxHeight) {

                                    minImageHeight = thisImageHeight;

                                }
                                else {
                                    minImageHeight = thisImageMaxHeight;
                                }
                        }

                        /*Blogs*/
                        if ($(currentCarousel).hasClass('carouselGalleryBlogs')) {
                            var imageWidthRight = $(this).width() + 24;
                            $('.fadedNext', this).css('margin-left', imageWidthRight + 'px');
                        }
                            
                    });
                    $('.carousel-item img', currentCarousel).css('max-height', minImageHeight + 'px');
                    $('.carousel-item .imgHolder', currentCarousel).css('min-height', minImageHeight + 'px');

                    $('.carousel-item', currentCarousel).each(function () {
                        $(this).removeAttr('style')
                    });

                    /*Vimeo*/
                    $('.vimeoVideo', currentCarousel).each(function () {
                        $(this).find('iframe').css('max-height', minImageHeight + 'px');

                    });


                    $('.galleryContent', currentCarousel).css('min-height', maxContentHeight + 'px');

                    $('.carousel-item.active').show();

                    if ($(currentCarousel).find(".Individual").length > 0) {
                        var contentID = $('.carousel-item.active', currentCarousel).attr('content-data');
                        $('#' + contentID, currentCarousel).show();
                    }


                    leftAlign(currentCarousel);


                }
                function caption(currentCarousel) {
                    if ($(currentCarousel).find(".captionSection").length > 0) {
                        var currentSlide = $('.carousel-item.active', currentCarousel);
                        var imgWidth = $('img.original', currentSlide).width() + 30;
                        $('.captionSection .container', currentSlide).css('width', imgWidth + 'px');
                    }
                }

                function leftAlign(currentCarousel) {
                    if ($(window).width() >= 992) {
                        var orgWidth = $('.carousel-item.active .original', currentCarousel).width();
                        var prevWidth = $('.carousel-item.active .fadedPrev', currentCarousel).width();
                        var itemWidth = $('.carousel-item.active').outerWidth();

                        if ($('.carousel-item.active .original', currentCarousel).hasClass('videoImage') || $('.carousel-item.active .fadedPrev', currentCarousel).hasClass('videoImage')) {
                            if (orgWidth < itemWidth) {
                                var newGap = itemWidth - orgWidth
                                var halfGap = newGap / 2
                                prevMargin = prevWidth - halfGap + 24
                                $('.carousel-item.active .fadedPrev', currentCarousel).css('margin-left', '-' + prevMargin + 'px');
                            }
                        } 
                    }
                    
                }


                //On slide
                $('.carousel').on('slide.bs.carousel', function (e) {
                    var currentCarousel = $(this);
                    if ($(this).find(".Individual").length > 0) {
                        $('.Individual', currentCarousel).hide();

                    }

                    $(".carousel-item iframe", currentCarousel ).each(function () {
                        var src = $(this).attr('src');
                        $(this).attr('src', src);
                    });
                    
                });

                //After slide
                $('.carousel').on('slid.bs.carousel', function (e) {
                    var currentCarousel = $(this);

                    
                    modules.sliderControls(currentCarousel);

                    if ($(this).find(".Individual").length > 0) {
                        var contentID = $('.carousel-item.active', currentCarousel).attr('content-data');
                        $('#' + contentID, currentCarousel).fadeIn(500);
                    }
                    leftAlign(currentCarousel);
                    caption(currentCarousel); 
                });


                window.loadedModules('app-CarouselGalleryComponent');
            }
        }
    }
);
